// Libraries
import { Box, Heading, ListItem, OrderedList, Text } from "@chakra-ui/react";
import React, { Fragment } from "react";
// Recoil
import { useRecoilValue } from "recoil";
import LoggedInActionLinks from "../components/Classes/ActionLinks";
import UserLayoutv2 from "../components/UserLayoutv3";
import { authData } from "../State";

// import Dummy from './../components/UI/Dummy';

const Privacy = () => {
  // Recoil
  const { loggedIn, studentData } = useRecoilValue(authData);

  return (
    <UserLayoutv2
      title="Privacy Policy"
      customLeftWidth={{ base: "0%", lg: "20%" }}
      left={
        <Fragment>
          {loggedIn ? (
            <LoggedInActionLinks classesData={studentData.joined_classes} />
          ) : (
            <Box
              h="100%"
              py={10}
              // px={12}
            ></Box>
          )}
        </Fragment>
      }
      customMainWidth={loggedIn ? { base: "100%", lg: "60%" } : { base: "100%", lg: "80%" }}
      main={
        <Box pb={12} mb={6} px={{ base: 4, lg: 16 }} h="100%" w="100%">
          <Box w="100%" mt={loggedIn ? 0 : 10}>
            <Heading as="h1" fontSize="xl" mb={5} fontWeight={900} color="blue.500">
              Privacy Policy
            </Heading>

            <Text fontWeight="700" color="gray.500" mb={8}>
              This Privacy Policy describes how your personal information is collected, used, and shared when you visit or make a purchase
              from learntific.com (the “Site”).
            </Text>

            <Text fontWeight="800">PERSONAL INFORMATION WE COLLECT</Text>
            <Text mb={4}>
              When you visit the Site, we automatically collect certain information about your device, including information about your web
              browser, IP address, time zone, and some of the cookies that are installed on your device. Additionally, as you browse the
              Site, we collect information about the individual web pages or products that you view, what websites or search terms referred
              you to the Site, and information about how you interact with the Site. We refer to this automatically-collected information as
              “Device Information.”
            </Text>
            <Text>We collect Device Information using the following technologies:</Text>
            <OrderedList mb={4}>
              <ListItem>
                “Cookies” are data files that are placed on your device or computer and often include an anonymous unique identifier. For
                more information about cookies, and how to disable cookies, visit http://www.allaboutcookies.org.
              </ListItem>
              <ListItem>
                “Log files” track actions occurring on the Site, and collect data including your browser type, referring/exit pages, and
                date/time stamps.
              </ListItem>
            </OrderedList>

            <Text mb={4}>
              Additionally when you make a purchase or attempt to make a purchase through the Site, we collect certain information from you,
              including your name, billing address, payment information (including credit card numbers), email address, and phone number. We
              refer to this information as “Payment Information.”
            </Text>

            <Text mb={8}>
              When we talk about “Personal Information” in this Privacy Policy, we are talking both about Device Information and Payment
              Information.
            </Text>

            <Text fontWeight="800">HOW DO WE USE YOUR PERSONAL INFORMATION?</Text>
            <Text mb={8}>
              We use the Payment Information that we collect generally to fulfill any purchase placed through the Site (including your
              payment information, and providing you with invoices and/or order confirmations). We use the Device Information that we
              collect to help us generally to improve and optimize our Site (for example, by generating analytics about how our users browse
              and interact with the Site, and to assess the success of our marketing and advertising campaigns).
            </Text>

            <Text fontWeight="800">SHARING YOUR PERSONAL INFORMATION</Text>
            <Text mb={8}>
              We use Plausible Analytics and Google Analytics to help us understand how our customers use the Site--you can read more about
              how Google uses your Personal Information <a href="https://www.google.com/intl/en/policies/privacy/">here</a>. You can also
              opt-out of Google Analytics here: https://tools.google.com/dlpage/gaoptout. Finally, we may also share your Personal
              Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request
              for information we receive, or to otherwise protect our rights.
            </Text>

            <Text fontWeight="800">CHANGES</Text>
            <Text mb={8}>
              We may update this privacy policy from time to time in order to reflect, for example, changes to our practices or for other
              operational, legal or regulatory reasons.
            </Text>

            <Text fontWeight="800">CONTACT US</Text>
            <Text mb={2}>
              For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please
              contact us by using the details provided below:
            </Text>
            <Text mb={10}>
              VaultNoir Limited,
              <br /> Vancouver, Canada
              <br /> hello@learntific.com
            </Text>
          </Box>
        </Box>
      }
      customRightWidth={loggedIn ? { base: "0%", lg: "20%" } : "0"}
      right={<Box d={loggedIn ? { base: "none", lg: "block" } : "none"} h="100%" pt={10} pl={6}></Box>}
    />
  );
};

export default Privacy;
